import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
// import "./dashboard.scss";

class ApexRadial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chart: {
        height: 400,
        type: "radialBar",
        offsetY: -10,
      },
      options: {
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: "13px",
                color: void 0,
                offsetY: 60,
              },
              value: {
                offsetY: 22,
                fontSize: "16px",
                color: void 0,
                formatter: function (e) {
                  return e + "%";
                },
              },
            },
          },
        },
        colors: ["#556ee6"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            shadeIntensity: 0.15,
            inverseColors: !1,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91],
          },
        },
        stroke: {
          dashArray: 4,
        },
        labels: ["Profit"],
      },
      series: [110],
    };
  }

  render() {
    const generatePercent = () => {
      let num = ((21400/ 3).toFixed(2) / 25000) * 100;
      return [num.toFixed(2)];
    };

    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={generatePercent()}
          type="radialBar"
          height="190"
          className="apex-charts"
        />
      </React.Fragment>
    );
  }
}

ApexRadial.propTypes = {
  date: PropTypes.object,
  data: PropTypes.object,
};

export default ApexRadial;
